import api from "./utils/api";
import { getAuthToken } from "./utils/tokens";

// FOR ADMIN ONLY
const createOffer = async (offer) => {
  try {
    // console.log("Offer to be: ", offer);
    const token = getAuthToken();
    //   PREPARE FORM DATA
    const formData = new FormData();
    formData.append("title", offer.title);
    formData.append("description", offer.description);
    formData.append("product", offer.product);
    formData.append("discountType", offer.discountType);
    formData.append("discountValue", offer.discountValue);
    formData.append("maximumDiscount", offer.maximumDiscount);
    formData.append("minimumPurchase", offer.minimumPurchase);
    formData.append("startDate", offer.startDate);
    formData.append("endDate", offer.endDate);
    formData.append("isActive", offer.isActive);
    formData.append("image", offer.image);
    const response = await api.post("/offer/create", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multiple/form-data",
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};
const updateOffer = async (offerId, formDataRef) => {
  try {
    const token = getAuthToken();
    //   PREPARE FORM DATA

    const offer = await api.put(`/offer/${offerId}`, formDataRef.current, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multiple/form-data",
      },
    });
    return offer.data;
  } catch (err) {
    // console.log("error: ", err);
    throw err;
  }
};

// DELETE OFFER (FOR ADMIN ONLY)
const deleteOffer = async (offerId) => {
  const token = getAuthToken();
  try {
    await api.delete(`/offer/${offerId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (err) {
    throw err;
  }
};
const getAllOffers = async () => {
  try {
    const offers = await api.get("/offers");
    return offers.data;
  } catch (err) {
    throw err;
  }
};
// ------------------ ( FOR USERS )

const getAllActiveOffers = async () => {
  try {
    const offers = await api.get("/offers/active");
    return offers.data;
  } catch (err) {
    throw err;
  }
};
const getOneOffer = async (offerId) => {
  try {
    const offer = await api.get(`/offer/${offerId}`);
    return offer.data;
  } catch (err) {
    throw err;
  }
};
const getOfferImage = async (offerId) => {
  try {
    const data = await api.get(`/offer/image/${offerId}`);
    return data.data;
  } catch (err) {
    throw err;
  }
};
export {
  // FOR ADMIN
  createOffer,
  deleteOffer,
  updateOffer,
  getAllOffers,
  // FOR USERS
  getAllActiveOffers,
  getOfferImage,
  getOneOffer,
};
